'use es6';

import ComponentWithPartials from 'UIComponents/mixins/ComponentWithPartials';
import GoodFiltersAndPage from '../constants/GoodFiltersAndPage';
import PropTypes from 'prop-types';
import createReactClass from 'create-react-class';
import React from 'react';
import SortOptions from '../constants/SortOptions';
import UIButton from 'UIComponents/button/UIButton';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIList from 'UIComponents/list/UIList';
import { getFriendlySortingOptionName } from '../utils/langUtils';

var getSortOptions = function getSortOptions() {
  return [SortOptions.MOST_DOWNLOADED, SortOptions.RECENTLY_ADDED, SortOptions.PRICE_LOW_TO_HIGH, SortOptions.PRICE_HIGH_TO_LOW];
};

export default createReactClass({
  displayName: "SortOptionsDropdown",
  mixins: [ComponentWithPartials],
  propTypes: {
    buttonClassName: PropTypes.string,
    onGoodFilterChange: PropTypes.func.isRequired,
    sortingFilter: PropTypes.string.isRequired
  },
  getGoodFilterChangeHandlerForSorting: function getGoodFilterChangeHandlerForSorting(sortingFilter) {
    var params = {};
    params[GoodFiltersAndPage.SORT_BY] = sortingFilter;
    return this.props.onGoodFilterChange(params);
  },
  renderDropdownItems: function renderDropdownItems(sortingFilter) {
    var _this = this;

    return getSortOptions().map(function (sortingOption) {
      if (sortingOption !== sortingFilter) {
        return React.createElement(UIButton, {
          className: "integrate-" + sortingOption,
          key: sortingOption,
          onClick: _this.partial(_this.getGoodFilterChangeHandlerForSorting, sortingOption),
          use: "link"
        }, getFriendlySortingOptionName(sortingOption));
      }

      return null;
    });
  },
  render: function render() {
    var _this$props = this.props,
        buttonClassName = _this$props.buttonClassName,
        sortingFilter = _this$props.sortingFilter;
    return React.createElement(UIDropdown, {
      buttonClassName: "integrate-sort-dropdown-button p-all-0 " + buttonClassName,
      buttonText: getFriendlySortingOptionName(sortingFilter),
      buttonUse: "transparent"
    }, React.createElement(UIList, null, this.renderDropdownItems(sortingFilter)));
  }
});